import { formatQuoteAsOf, quoteBadgeLabel } from './freshness';
import type { QuoteResponse } from '@biasafe.models';
import { AdvisorText } from '@/shared/components/AdvisorText';
import { cn } from '@/lib/utils';

const EXPLAIN: Record<string, string> = {
  Delayed: 'This price is delayed. Your market data feed is not real-time.',
  'Prior close': 'The market is not trading now. This is the previous close.',
  Halted:
    'Trading in this symbol is halted. The price is the last one before the halt.',
};

/**
 * A small badge when the quote is not plainly live, and the time it was read.
 * A live quote shows no badge, only "as of".
 */
export function QuoteStateBadge({
  quote,
  className,
}: {
  quote: Pick<QuoteResponse, 'quoteState' | 'asOf'>;
  className?: string;
}) {
  const label = quoteBadgeLabel(quote.quoteState);
  const asOf = formatQuoteAsOf(quote.asOf);
  if (!label && !asOf) return null;
  return (
    <span
      className={cn(
        'flex items-center gap-1.5 text-[11px] text-muted-foreground',
        className,
      )}
    >
      {label && (
        <span
          title={EXPLAIN[label]}
          className={cn(
            'rounded px-1.5 py-0.5 font-medium',
            label === 'Halted'
              ? 'bg-rose-50 text-rose-700'
              : 'bg-amber-50 text-amber-800',
          )}
        >
          {label}
        </span>
      )}
      {asOf && (
        <span className="tabular-nums">
          <AdvisorText source={'as of'} /> {asOf}
        </span>
      )}
    </span>
  );
}
